module.exports = __webpack_public_path__ + "img/garantia.871f5685.png";